import * as React from 'react'

import { Site } from '../../../../common/constants/siteList'
import { searchesCount } from '../../../../common/utils/tracking/trackSearchCount'
import SearchSurveyBanner from './searchSurveyBanner'

interface IProps {
  currentSite: Site
}

const GraphicRiverEaseOfUseSurvey: React.StatelessComponent<IProps> = props => {
  const { currentSite } = props
  const showBanner =
    currentSite === Site.graphicriver && searchesCount(Site.graphicriver) > 2

  if (!showBanner) {
    return null
  }

  return (
    <div className="tfEaseOfSurveyContainer">
      <SearchSurveyBanner
        siteId="gr"
        surveyUrl="https://www.surveymonkey.com/r/YRGJHCN"
        surveyText="Interested in improving GraphicRiver? Tell us what's important to you, we'd love to know."
        surveyLink="Share your thoughts here!"
      />
    </div>
  )
}

export default GraphicRiverEaseOfUseSurvey
